import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SidebarIconContacts from './sidebar-icon-contacts.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SidebarIconContacts {...validProps} />;
}
SvgComponent.iconName = 'sidebarIconContacts';

/**
 * @deprecated This is a legacy icon
 */
export const SidebarIconContactsIcon = svgIconWrapper(SvgComponent);
